<template>
	<div class="text">
		<p>本用户充值协议（以下称“本协议”）由您与芝麻招工（以下称“本平台”）运营主体上海博夫教育科技有限公司（以下称“公司”）签订；本平台按照本协议规定及不时发布的操作规则提供基于互联网的充值服务（以下称“充值服务”）。为更好地向用户提供充值服务，请服务使用人（以下称“用户”或“您”）开始使用充值服务之前认真阅读并充分理解本协议，
		</p>
		<p>其中，免除或者限制责任条款等重要内容将以加粗形式提示注意，请您重点阅读。</p>
		<p>如您自主选择按照页面提示完成充值程序，则视为您已同意并接受本协议项下的全部条款。</p>
		<p>如您不同意本协议，请您立即停止充值。</p>
		<p>本平台不鼓励未成年人使用充值服务，未成年人请委托监护人操作或在监护人明示同意下操作，否则请勿使用本充值服务。</p>
		<p class="head">第一章 服务规则</p>
		<p>1、“积分”是本平台向您提供的用于在本平台上进行相关消费的虚拟币，您可以用“积分”在本平台上进行查看招工信息电话等产品或服务（具体可在产品相应的服务页面查看说明）。</p>
		<p>2、您充值购买“积分”的费用将由公司或公司指定的合作方向您收取。各充值方式对应的渠道商可能会按其标准制定相关充值渠道手续费用，并在用户充值时收取，请用户务必注意各充值方式的渠道商服务手续费，并按自身需求选取充值方式。
		</p>
		<p>3、平台倡导理性消费，请您务必根据自身实际需求购买相应数量的“积分”，同时，在充值过程中，请您务必谨慎确认您充值的帐号或账号绑定的手机号码，并仔细选择及/或输入充值账号/账号绑定手机号码、充值金额等相关操作选项。若因您自身输入帐号/账号绑定手机号错误、金额错误、操作不当或不了解、未充分了解充值计费方式等因素造成充错帐号、充值金额错误、错选充值种类等情形而导致自身权益受损的，由此带来的损失由您自行承担，本平台不会作出补偿或赔偿。
		</p>
		<p>4、请您务必使用本平台指定的官方充值方式进行充值。若您使用非本平台所指定的充值方式或非法的方式进行充值，本平台不保证该充值顺利或者正确完成，同时可能引发其他风险，若因此造成您或任何第三方权益受损，由您自行应对处理并承担相应责任，本平台不会作出任何补偿或赔偿，同时本平台保留随时中止您的帐号部分或全部权限、冻结您的帐户余额、短期或永久封禁您的帐号及/或禁止您使用各项充值服务的权利。
		</p>
		<p>5、如果本平台发现因系统故障或其他任何原因导致的处理错误，无论有利于本平台还是有利于您，本平台都有权纠正该错误。如果该措施导致您实际收到的“积分”数量少于您应获得的“积分”，则本平台在确认该处理错误后会尽快将差额补足至您的帐户中。如果该错误导致您实际收到的“积分”数量多于您应获得的“积分”，则无论错误的性质和原因如何，本平台有权从您的帐户中直接扣除差额。
		</p>
		<p class="head">第二章 权利声明</p>
		<p>1、您理解并同意，本平台有权基于交易安全、运营策略、行业惯例等方面的考虑不时设定涉及交易的相关限制和提醒事项，包括但不限于交易限额、交易次数等。</p>
		<p>2、如充值过程中涉及由第三方提供的相关服务，则除遵守本协议约定外，您还需要同意并遵守该等第三方的协议及相关规则，在任何情况下，对于该第三方及其提供的相关服务而产生的争议由您自行与该第三方解决，本平台无需就此向您或该第三方承担任何责任。
		</p>
		<p>3、因您自身的原因导致本平台无法提供“积分”购买服务或提供“积分”购买服务时发生任何错误而产生的任何损失或责任，由您自行负责，本平台不承担责任，包括但不限于：</p>
		<p>（1）因您的帐号失效、丢失、被封停；</p>
		<p>（2）因您绑定的第三方支付机构、银行等帐户的原因导致的损失或责任，包括您使用未经认证的帐户或使用非您本人的帐户，您的帐户被冻结、查封等；</p>
		<p>（3）您将密码告知他人导致的财产损失；</p>
		<p>（4）因您个人的故意或重大过失所造成的财产损失。</p>
		<p>4、因下列状况导致您无法使用本平台的充值服务或使您的任何虚拟财产丢失时，您同意本平台无须承担损害赔偿责任，该状况包括但不限于：</p>
		<p>（1）在本平台公告之系统停机维护、升级、调整期间；</p>
		<p>（2）电信通讯或设备出现故障不能进行数据传输的；</p>
		<p>（3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制等不可抗力之因素，造成本平台系统障碍不能执行业务的；</p>
		<p>（4）由于黑客攻击、电信部门技术调整或故障、网站升级、相关第三方的问题等原因而造成的服务中断或者延迟。</p>
		<p>5、您保证用于“积分”充值的资金均为您的合法收入所得，且您有充分权利按照本协议约定使用，因您违反本条而产生的任何争议或纠纷，由您自行处理解决，并承担由此带来的全部责任及法律后果。同时，平台发现（包括但不限于主动发现、收到第三方投诉或权力机关通知等情形）存在上述事由，有权单方决定限制您使用全部或部分充值“积分”、暂停或终止向您提供充值服务或对您的帐号采取进一步管理措施；如因此给平台造成损失的，您应予以全额赔偿，同时，平台有权保存相关信息，并向相关执法/司法机构、主管部门报告。
		</p>
		<p>6、若您使用平台为您开通的专属充值账号服务（如开通），您应遵守所有适用的与反洗钱、反诈骗、反恐怖主义融资、经济制裁相关的法律法规（“反洗钱相关法律规定”）。您承诺不得利用该专属充值账号进行洗钱等任何非法活动，也不得接受他人利用您通过该专属充值账号完成洗钱等的任何非法要求。若该专属充值账号发生任何异常交易，平台有权根据反洗钱相关法律规定及/或监管机构要求采取暂停该专属充值账号、展开调查等措施，且无须承担您因此所遭受的任何损失或损害。您确认您向平台提供的身份信息及资料完全真实有效，并且愿意按照法律规定及平台的要求协助和配合监管机构的调查。
		</p>
		<p>7、在任何情况下，本平台均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害承担责任。本平台对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用本平台提供的充值服务而支付的费用。</p>
		<p class="head">第三章 处罚规则</p>
		<p>1、如发生下列任何一种情形，本平台有权随时中断或终止向您提供本协议项下的网络服务（而无需另行单独通知您），且无需承担因充值服务中断或终止而给您或任何第三方造成损失的任何责任：</p>
		<p>（1）您提供的个人资料不真实；</p>
		<p>（2）您违反本协议或其他本平台对用户的管理规定；</p>
		<p>（3）您以非法目的购买、使用“积分”。</p>
		<p>2、用户在使用本平台提供的充值服务时，如出现任何的涉嫌犯罪、违法违规、违反社会主义道德风尚、违反《用户服务协议》、本协议或其他本平台对用户的管理规定的情形，本平台有权视您行为的性质及严重程度决定对您的帐号采取暂时或永久封禁措施。帐号封禁后至解禁（如有）前，您帐户上剩余的“积分”将被暂时冻结或全部扣除，不可继续用于购买本平台的产品及/或服务，同时不予返还您购买“积分”时的现金价值。
		</p>
		<p class="head">第四章 附则</p>
		<p>1、为了向您提供更好的服务，或者基于法律规定、主管部门要求、业务开展情况等因素的更新与变化，本平台将适时对本协议内容进行修订，该等修订内容一经公布立即生效，本平台将通过本平台发出更新版本，您可通过“积分”充值页面随时查阅最新版本的协议条款。若您在本协议内容发生修订后继续使用本平台提供的充值服务的，则视为您同意最新修订的协议内容；否则请您立即停止充值。
		</p>
		<p>2、您理解并同意，本平台提供的充值服务是按照现有技术和条件所能达到的现状提供的，本平台会尽最大努力向您提供充值服务，确保充值服务的连贯性和安全性。但您亦知悉并认可，本平台不能随时或始终预见和防范技术及其他风险，包括但不限于因不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用充值服务以及其他的损失和风险；此外，除前述情况外，本平台有权视交易安全、运营规划等具体情况随时中断、中止或终止本协议项下充值服务，并将以本平台页面公告或其他适当方式向用户发出通知（而不再另行单独通知您）。
		</p>
		<p>3、因本协议引起的或与本协议有关的争议，均适用中华人民共和国法律。若本协议之任何规定因与中华人民共和国法律抵触或被有管辖权的人民法院认定而无效或不可执行，则在不违反法律的前提下，这些条款将按照尽可能接近本协议原条文意旨的原则重新解析，且本协议其它规定仍应具有完整的效力及效果。
		</p>
	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '《芝麻招工用户充值协议》'
		}
	}
</script>

<style>
	text {
		padding: 15px;
		font-size: 14px;
		color: #333;
	}

	.text p {
		line-height: 1.6;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
